module.exports = __webpack_public_path__ + "img/2.28f23dc8.jpg";